import React, { useState, useCallback } from 'react'
import { Accordion } from '../../components/modules/Accordion'
import { css } from '@emotion/core'
import axios from 'axios'
import { constCategories } from '../../../utils/constants'
import { ModalCheckbox } from './ModalCheckbox'
import { InputCheckBox } from './InputCheckBox'

axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'

export const SearchModalNormal = ({
  hide,
  addFiltering,
  setThinning,
  setSearchFlag,
  filtering,
  products = [],
  triggerSearch
}: any) => {
  const [customerName, setCustomerName] = useState(filtering.name)
  const [customerAddress, setCustomerAddress] = useState(filtering.address)
  const [customerNumber, setCustomerNumber] = useState(filtering.number)
  const [checkedIndustries, setCheckedIndustries] = useState<{
    [key: string]: string
  }>(filtering.industries)
  const [checkedServices, setCheckedServices] = useState<{
    [key: string]: string
  }>(filtering.services)
  const [completedFrom, setCompletedFrom] = useState(filtering.completedFrom || '')
  const [completedTo, setCompletedTo] = useState(filtering.completedTo || '')
  const [onlySameRepresentative, setOnlySameRepresentative] = useState(
    filtering.onlySameRepresentative ?? true
  )

  // Modal開閉管理
  const [isIndustoryOpen, setIndustoryOpen] = useState(false)
  const [isServiceOpen, setServiceOpen] = useState(false)

  const changeOpenState = (key: string) => {
    switch (key) {
      case 'industory':
        setIndustoryOpen(!isIndustoryOpen)
        break
      case 'service':
        setServiceOpen(!isServiceOpen)
        break
    }
  }

  const changeName = useCallback((e: any) => {
    setCustomerName(e.target.value)
  }, [])
  const changeAddress = useCallback((e: any) => {
    setCustomerAddress(e.target.value)
  }, [])

  const changeNumber = useCallback((e: any) => {
    setCustomerNumber(e.target.value)
  }, [])
  const changeIndustries = useCallback(
    (e: any) => {
      setCheckedIndustries({
        ...checkedIndustries,
        [e.target.id]: e.target.checked
      })
    },
    [checkedIndustries]
  )
  const changeServices = useCallback(
    (e: any) => {
      setCheckedServices({
        ...checkedServices,
        [e.target.id]: e.target.checked
      })
    },
    [checkedServices]
  )

  const filter = {
    name: customerName,
    address: customerAddress,
    number: customerNumber,
    industries: checkedIndustries,
    services: checkedServices,
    scenario: {},
    completedFrom,
    completedTo,
    onlySameRepresentative,
  }

  const clearSearchInput = () => {
    setCustomerName('')
    setCustomerAddress('')
    setCustomerNumber('')
    setCheckedIndustries({})
    setCheckedServices({})
    setCompletedFrom('')
    setCompletedTo('')
    setOnlySameRepresentative(true)
  }

  const sendSearchInput = () => {
    setSearchFlag(1)
    if (triggerSearch) {
      triggerSearch(filter)
    } else {
      addFiltering(filter)
    }
    hide()
  }

  return (
    <>
      <div>
        <div css={formRow}>
          <p css={formLabel}>顧客名</p>
          <input
            css={formInput}
            type="text"
            placeholder="顧客名"
            onChange={changeName}
            value={customerName}
          />
        </div>
        <div css={formRow}>
          <p css={formLabel}>住所</p>
          <input
            css={formInput}
            type="text"
            placeholder="住所"
            onChange={changeAddress}
            value={customerAddress}
          />
        </div>
        <div css={formRow}>
          <p css={formLabel}>電話番号</p>
          <input
            css={formInput}
            type="tel"
            placeholder="電話番号"
            onChange={changeNumber}
            value={customerNumber}
          />
        </div>

        <div css={formRow}>
          <p css={formLabel}>業態</p>
          <div css={formContent}>
            <Accordion
              title="選択してください"
              keyword=""
              isOpen={isIndustoryOpen}
              changeOpen={() => changeOpenState('industory')}
            >
              {constCategories.map(item => (
                <ModalCheckbox
                  item={item}
                  array={checkedIndustries}
                  onChange={changeIndustries}
                  key={item.id}
                />
              ))}
            </Accordion>
          </div>
        </div>
        <div css={formRow}>
          <p css={formLabel}>獲得済み商材</p>
          <div css={formContent}>
            <Accordion
              title={products.length > 0 ? '選択してください' : '商材を読み込み中...'}
              keyword=""
              isOpen={isServiceOpen}
              changeOpen={() => changeOpenState('service')}
            >
              {products.length === 0 ? (
                <span css={productsEmptyMsg}>商材一覧を読み込んでいます。表示されない場合はページを再読み込みしてください。</span>
              ) : (
                products.map(item => (
                  <ModalCheckbox
                    item={item}
                    array={checkedServices}
                    onChange={changeServices}
                    key={item.id}
                  />
                ))
              )}
            </Accordion>
          </div>
        </div>
        <div css={formRow}>
          <p css={formLabel}>完了日</p>
          <div css={formContent}>
            <div css={dateRange}>
              <input
                css={formInput}
                type="month"
                value={completedFrom}
                onChange={e => setCompletedFrom(e.target.value)}
              />
              <span css={dateSeparator}>〜</span>
              <input
                css={formInput}
                type="month"
                value={completedTo}
                onChange={e => setCompletedTo(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div css={formRow}>
          <p css={formLabel}>表示範囲</p>
          <div css={formContent}>
            <InputCheckBox
              onChange={() => setOnlySameRepresentative(!onlySameRepresentative)}
              val={onlySameRepresentative}
              text={'代表者と担当者が同じピンのみ表示'}
            />
          </div>
        </div>
      </div>
      <div css={btnArea}>
        <button
          css={clearBtn}
          type="button"
          className="modal-close-button"
          data-dismiss="modal"
          aria-label="Close"
          onClick={() => clearSearchInput()}
        >
          <span aria-hidden="true">Clear</span>
        </button>
        <button css={searchBtn} onClick={() => sendSearchInput()}>
          Search
        </button>
      </div>
    </>
  )
}

/* ---- 共通レイアウト ---- */

const formRow = css`
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`

const formLabel = css`
  font-weight: bold;
  width: 15%;
  flex-shrink: 0;
  margin-bottom: 0;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 5px;
  }
`

const formContent = css`
  flex: 1;
  min-width: 0;
  & > div {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
`

const formInput = css`
  font-family: sans-serif;
  width: 100%;
  border: 1px solid #eee;
  background-color: #eee;
  padding: 10px;
  font-size: 16px;
  border-radius: 3px;
  -webkit-appearance: none;
  box-sizing: border-box;
`

/* ---- 完了日 ---- */

const dateRange = css`
  display: flex;
  align-items: center;
`

const dateSeparator = css`
  margin: 0 8px;
  color: #666;
  flex-shrink: 0;
`

/* ---- その他 ---- */

const productsEmptyMsg = css`
  font-size: 13px;
  color: #666;
  display: block;
  padding: 8px 0;
`

const btnArea = css`
  width: 80%;
  max-width: 600px;
  margin: auto;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column-reverse;
    margin-top: 15px;
  }
`

const searchBtn = css`
  font-family: inherit;
  cursor: pointer;
  font-size: 16px;
  width: 220px;
  padding: 8px 30px;
  border-radius: 20px;
  border: none;
  background: #0e2851;
  color: #ffffff;
  outline: none;
  margin: auto;
  @media (max-width: 768px) {
    width: 180px;
    margin-bottom: 10px;
  }
`

const clearBtn = css`
  font-family: inherit;
  cursor: pointer;
  font-size: 16px;
  width: 220px;
  padding: 8px 30px;
  border-radius: 20px;
  border: none;
  background: #cccccc;
  color: #ffffff;
  outline: none;
  margin: auto;
  @media (max-width: 768px) {
    width: 180px;
  }
`
